import React, { useEffect, useState } from "react";
import "./Analytics.css";
import { useParams } from "react-router-dom";
import { getUserAnalytics } from "../../apis";

const Analytics = () => {
  const { id } = useParams();
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUserAnalytics = async () => {
    try {
      setLoading(true);
      const response = await getUserAnalytics(id);
      if (response?.data?.data) {
        setAnalytics(response.data.data);
      } else {
        setAnalytics({});
      }
    } catch (error) {
      console.error("Error fetching analytics:", error);
      setAnalytics({});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserAnalytics();
  }, []);
//   console.log("analytics",analytics)
  if (loading) return <div className="loading">Loading analytics...</div>;
  if (!analytics) return <div>No analytics found</div>;

  return (
    <div className="analytics-container">
      <h1 className="analytics-header">User Stats</h1>

      {/* --- Overview Cards --- */}
      <div className="overview-section">
        <div className="overview-card">
          <h3>Wardrobe Items</h3>
          <p>{analytics.wordrobItem}</p>
        </div>
        <div className="overview-card">
          <h3>Outfits</h3>
          <p>{analytics.outfitCount}</p>
        </div>
        <div className="overview-card">
          <h3>Shares</h3>
          <p>{analytics.shareCount}</p>
        </div>
      </div>

      {/* --- Top Colors --- */}
      <div className="analytics-section">
        <h2>Top three color in wardrobe</h2>
        <div className="color-grid">
          {analytics.topColor?.length ? (
            analytics.topColor.map((color, idx) => (
              <div key={idx} className="color-card">
                <div
                  className="color-swatch"
                  style={{ backgroundColor: color.primaryColorCode }}
                ></div>
                <p>{color.primaryColorName}</p>
                {/* <span>{color.count} items</span> */}
              </div>
            ))
          ) : (
            <p className="empty-text">No color data available.</p>
          )}
        </div>
      </div>

      {/* --- Most Owned Categories --- */}
      {/* <div className="analytics-section">
        <h2>Most Owned Categories</h2>
        <ul className="category-list">
          {analytics.mostOwnedCategory?.length ? (
            analytics.mostOwnedCategory.map((cat, idx) => (
              <li key={idx}>
                <span>{cat.categoryName}</span>
                <strong>{cat.count}</strong>
              </li>
            ))
          ) : (
            <p className="empty-text">No category data available.</p>
          )}
        </ul>
      </div> */}

      {/* --- Top Brands --- */}
      {/* <div className="analytics-section">
        <h2>Top Brands</h2>
        <ul className="brand-list">
          {analytics.topBrands?.length ? (
            analytics.topBrands.map((brand, idx) => (
              <li key={idx}>
                <span>{brand.brand}</span>
                <strong>{brand.count}</strong>
              </li>
            ))
          ) : (
            <p className="empty-text">No brand data available.</p>
          )}
        </ul>
      </div> */}
         <div className="analytics-section">
             <div className="analytics-header">
          <h2>Most Worn Items</h2>
          <span style={{ fontSize: "16px" }}>{analytics.topUsedWardrobItem?.length} Items</span>
        </div>

        <div className="outfit-grid">
          {analytics.topUsedWardrobItem?.length ? (
            analytics.topUsedWardrobItem.map((item) => (
              <div key={item._id} className="outfit-card">
                <img src={item.image} alt={item.name} />
                <h4>{item.name}</h4>
                {/* <p>{item.description || "No description"}</p>
                <span>{item.occasion?.join(", ") || "Casual"}</span> */}
              </div>
            ))
          ) : (
            <p className="empty-text">No outfits found.</p>
          )}
        </div>
      </div>
      <div className="analytics-section">

        <div className="analytics-header">
          <h2>Least Worn Items</h2>
          <span style={{ fontSize: "16px" }}>{analytics.getLeastUsedWardrobeItems?.length} Items</span>
        </div>
        <div className="outfit-grid">
          {analytics.getLeastUsedWardrobeItems?.length ? (
            analytics.getLeastUsedWardrobeItems.map((item) => (
              <div key={item._id} className="outfit-card">
                <img src={item.image} alt={item.name} />
                <h4>{item.name}</h4>
                {/* <p>{item.description || "No description"}</p>
                <span>{item.occasion?.join(", ") || "Casual"}</span> */}
              </div>
            ))
          ) : (
            <p className="empty-text">No outfits found.</p>
          )}
        </div>
      </div>
      {/* --- Recent Outfits --- */}
      <div className="analytics-section">
        <div className="analytics-header">
          <h2>Recent Outfits</h2>
          <span style={{ fontSize: "16px" }}>{analytics.getRecentOutfits?.length} Outfits</span>
        </div>
        <div className="outfit-grid">
          {analytics.getRecentOutfits?.length ? (
            analytics.getRecentOutfits.map((outfit) => (
              <div key={outfit._id} className="outfit-card">
                <img src={outfit.image} alt={outfit.name} />
                <h4>{outfit.name}</h4>
                {/* <p>{outfit.description || "No description"}</p>
                <span>{outfit.occasion?.join(", ") || "Casual"}</span> */}
              </div>
            ))
          ) : (
            <p className="empty-text">No outfits found.</p>
          )}
        </div>
      </div>
      <div className="analytics-section">

        <div className="analytics-header">
          <h2>Most Worn Outfits</h2>
          <span style={{ fontSize: "16px" }}>{analytics.mostWornOutfits?.length} Outfits</span>
        </div>
        <div className="outfit-grid">
          {analytics.mostWornOutfits?.length ? (
            analytics.mostWornOutfits.map((outfit) => (
              <div key={outfit._id} className="outfit-card">
                <img src={outfit.image} alt={outfit.name} />
                <h4>{outfit.name}</h4>
                {/* <p>{outfit.description || "No description"}</p>
                <span>{outfit.occasion?.join(", ") || "Casual"}</span> */}
              </div>
            ))
          ) : (
            <p className="empty-text">No outfits found.</p>
          )}
        </div>
      </div>
      <div className="analytics-section">
        <div className="analytics-header">
          <h2>Least Worn Outfits</h2>
          <span style={{ fontSize: "16px" }}>{analytics.leastWornOutfits?.length} Outfits</span>
        </div>
        
        <div className="outfit-grid">
          {analytics.leastWornOutfits?.length ? (
            analytics.leastWornOutfits.map((outfit) => (
              <div key={outfit._id} className="outfit-card">
                <img src={outfit.image} alt={outfit.name} />
                <h4>{outfit.name}</h4>
                {/* <p>{outfit.description || "No description"}</p>
                <span>{outfit.occasion?.join(", ") || "Casual"}</span> */}
              </div>
            ))
          ) : (
            <p className="empty-text">No outfits found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Analytics;
